<template>
  <div>
    <b-row>
      <b-container>
        <h1 class="text-center py-2">
          Administra los usuarios que utilizan la APP
        </h1>
      </b-container>
    </b-row>
    <b-row>
      <b-container>
        <h4 class="text-center border-bottom">
          Instrucciones
        </h4>
        <b-col md="8" class="mx-auto">
          <ul>
            <li >Bienvenid@ a la plataforma para la visualización y creación de usuarios</li>
          </ul>
        </b-col>
      </b-container>
    </b-row>
    <b-row v-if="!isLoading">
      <b-container>
        <b-col md="10" class="mx-auto"> 
          <md-button @click="goToCreateUser()" class="md-primary">Crear</md-button>
        </b-col>
      </b-container>
      <b-container v-if="!isEmpty" class="pb-5">
        <h4 class="text-center">
          Información General
        </h4>
        <b-col md="12" class="mx-auto">
        <md-table
          v-model="searched"
          :md-sort.sync="currentSort"
          :md-sort-order.sync="currentSortOrder"
          :md-sort-fn="customSort"
          md-card
        >
          <md-table-toolbar>
            <md-field md-clearable class="md-toolbar-section-start">
              <md-input
                placeholder="Buscar por Nombre de Usuario"
                v-model="search"
                @input="searchOnTable"
              />
            </md-field>
          </md-table-toolbar>

          <md-table-row slot="md-table-row" slot-scope="{ item }" @click="showInfo(item.id)">
            <md-table-cell md-label="Fecha Creación" md-sort-by="createdAt">{{
              item.createdAt
            }}</md-table-cell>
            <md-table-cell md-label="Nombre del usuario" md-sort-by="name">{{
              item.username
            }}</md-table-cell>
            <md-table-cell md-label="Correo Electrónico" md-sort-by="email">{{
              item.email
            }}</md-table-cell>
            <md-table-cell
                md-label="Estado"
                md-sort-by="enabled"
                >
                <span v-if="item.enabled > 0" class="policy-active">Activo</span>
                <span v-else class="policy-pending">Inactivo</span>
                </md-table-cell>
          </md-table-row>
        </md-table>
  </b-col>
        <b-col
          md="6"
          class="mx-auto empty-table pt-4"
          v-if="searched.length == 0 && users.length > 0 && !isLoading"
        >
          <h3>No hay Resgistros</h3>
          <p>No hay usuarios con el nombre: <span>{{ search }}</span></p>
        </b-col>
      </b-container>
      <b-container v-else>
        <b-col md="2" class="mx-auto">
          <div class="success-svg mb-4" :class="{ active: isEmpty }">
            <img src="../../assets/imgs/file-2.svg" alt="warning" />
          </div>
        </b-col>
        <b-col md="12" class="justify-content-around">
          <span id="message" v-if="isEmpty">Aún no cuentas con usuarios</span>
        </b-col>
      </b-container>
    </b-row>
    <b-row v-else>
      <b-col md="12" lg="12" class="p-4 mx-audo">
        <div class="text-center">
          <b-spinner></b-spinner>
        </div>
      </b-col>
    </b-row>
    <md-dialog :md-active.sync="showDialog">
      <md-dialog-title>Información del Usuario</md-dialog-title>
      <md-dialog-content>
          <b-row>
            <b-col>
              <h5>Nombre del Usuario:</h5>
            </b-col>
            <b-col>
              <h5>{{dialogItem.username}}</h5>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <h5>Correo Electrónico:</h5>
            </b-col>
            <b-col>
              <h5>{{dialogItem.email}}</h5>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <h5>Número de identificación:</h5>
            </b-col>
            <b-col>
              <h5>{{dialogItem.idNumber}}</h5>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <h5>Teléfono de contacto</h5>
            </b-col>
            <b-col>
              <h5>{{dialogItem.phone}}</h5>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <h5>Rol:</h5>
            </b-col>
            <b-col>
              <h5>{{dialogItem.role}}</h5>
            </b-col>
          </b-row>
         
      </md-dialog-content>

      <md-dialog-actions>
        <md-button class="md-accent" @click="showDialog = false">Cerrar</md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script>
import User from "@/services/User";
const toLower = (text) => {
  return text.toString().toLowerCase();
};

const searchByLocated = (items, term) => {
  if (term) {
    return items.filter((item) =>
      toLower(item.username).includes(toLower(term))
    );
  }

  return items;
};
export default {
  name: "List",

  data: () => ({
    currentSort: "createdAt",
    currentSortOrder: "asc",
    showDialog: false,
    dialogItem: {},
    users: [],
    searched: [],
    search: null,
    isEmpty: false,
    isUpdating: false,
    isLoading: false,
    success: false,
    error: false,
    filename: "List.xls"
  }),
  computed:{
    labels(){
      if (this.$store.state._language == "es-ES") {
        return {
          title: "Administra los usuarios que utilizan la APP",
          subtitle: "Instrucciones",
          instructive: ["Bienvenid@ a la plataforma para la visualización y creación de usuarios"],
          info: "Información General",
          search: "Buscar por Nombre de Usuario",
          information: "Información del Usuario",
          tapLabel: "Datos",
          createdAt: "Fecha Creación",
          name: "Nombre del usuario",
          email: "Correo Electrónico",
          companyId: "Id de la Compañia",
          phonenumber: "Teléfono de contacto",
          idNumber: "Número de identificación",
          role: "Rol del Usuario",
          empty: "Aún no cuentas con usuarios",
          create: "Crear",
          active: "Activo",
          inactive: "Inactivo",
          status: "Estado"
        }
      }else {
        return {
          title: "Invoice Visualization Platform",
          subtitle: "Instructions",
          instructive: ["Welcome to the platform for the visualization and creation of users."],
          info: "General Information",
          search: "Search by User Name",
          information: "Información del Usuario",
          tapLabel: "Datos",
          createdAt: "Created Date",
          name: "User Name",
          email: "Email",
          companyId: "Company Id",
          phonenumber: "Contact Number",
          idNumber: "Identification Id",
          role: "Role",
          empty: "You don't have users yet",
          create: "Create",
          active: "Activo",
          inactive: "Inactive",
          status: "Status"
        }
      }
    }
  },
  methods: {
    goToCreateUser(){
      this.$router.push({path: '/users/create'})
    },
    showInfo(id) {
      const currentIdx = this.users.findIndex((obj) => obj.id == id);
      this.dialogItem = this.users[currentIdx];
      console.log(this.dialogItem)
      this.showDialog = true
    },
    deleteUser(id) {
      this.isLoading = true;
      User.deleteUser(id).then(() => {
        this.isLoading = false;
      });
      this.users = this.users.filter( user => user.id != id );
      this.searched = this.users
    },
    customSort(value) {
      // console.log(value);
      return value.sort((a, b) => {
        const sortBy = this.currentSort;

        if (this.currentSortOrder === "desc") {
          return a[sortBy].toString().localeCompare(b[sortBy].toString());
        }

        return b[sortBy].toString().localeCompare(a[sortBy].toString());
      });
    },
    searchOnTable() {
      this.searched = searchByLocated(this.users, this.search);
    },
  },
  mounted() {
    this.isLoading = true;
    User.getAll()
      .then((result) => {
        // console.log(result.data)
        this.users = result.data.users;
        this.searched = this.users;
        if (this.users.length == 0) {
          this.isEmpty = true;
        }
      })
      .catch(() => {
        // console.log(error);
        this.error = true;
      })
      .finally(() => {
        this.isLoading = false;
      });
  },
};
</script>

<style src="../main.css">
</style>
